import { axiosClient } from "$/http"

import { ELogoutMutationUrl } from "@/3514/config"
import type { TLogoutMutationPayload, TLogoutMutationResponse } from "@/3514/mutations"

async function logoutMutator(params: TLogoutMutationPayload): Promise<TLogoutMutationResponse> {
    return axiosClient.post(ELogoutMutationUrl(), params)
}

export { logoutMutator }
